module.exports = __webpack_public_path__ + "img/img_empty.b5ee2376.png";